import { Link } from "react-router-dom";
import { Button } from '@chakra-ui/react';

const BoxThree = () => {
    return (
        <div className="App">
            <div className="App-body">
                <h1>Box Three - Location: Your Cubicle</h1>
                <p>
                    Stealthily making your way back, you slide into your chair and insert the 
                    flash drive into your computer. The screen immediately prompts you for a password. 
                    Your heart races as you realize that only something significant about Nina could 
                    unlock the secrets it holds. Who was it that she always quoted? Your memory 
                    could be the key.
                </p>
                <Button bg="#7c55d2" color="white" _hover={{bg:"#5a3cb0"}} as={Link} to='PuzzleFour'>Go to Puzzle Four</Button>
            </div>
        </div>
    );
  };
  
export default BoxThree;
  